module.exports = __webpack_public_path__ + "img/girl1.dab989bb.png";